import { MatchingRelationType } from "PFApp/constants/matching_relation_type";
import api from "PFCore/api";
import { decamelizeDesiredKeys } from "PFCore/helpers/decamelize_desired_keys";
import { Id, MatchedActivity, PaginatedCollection } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";

export type MatchingActivitiesParams = QueryParams & {
  profileId: Id;
  relationType: MatchingRelationType;
};

export type MatchingActivitiesResponse = PaginatedCollection<MatchedActivity[]>;

export const fetchMatchingActivities = (data: MatchingActivitiesParams) =>
  api<MatchingActivitiesResponse>({
    url: "matching_activities",
    method: "POST",
    data
  }).then((res) => decamelizeDesiredKeys<MatchingActivitiesResponse>(res, ["entries", "meta.filters"])); // TODO: [PROF-5746] Remove decamelizeKeys when app is camelized
